// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"19e10a62","703":"70c4e151","845":"f858bc42"}[chunkId] + ".chunk.js";
};